import { useEnvironment } from '@wix/yoshi-flow-editor';

export { useDescriptionRenderer } from './Description/hooks';
export { useOverviewRenderer } from './Overview/hooks';
export { useBadgesRenderer } from './Badges/hooks';
export { useBlogPostsRendered } from './BlogPosts/hooks';
export {
  useEmptyStateRenderer,
  useBlockedEmptyStateRenderer,
} from './EmptyState/hooks';

export const useIsResponsive = () => {
  const { dimensions, isEditorX } = useEnvironment();
  const widgetWidth = dimensions.width as number | string;

  return { isResponsive: isEditorX || widgetWidth === '' };
};
